// extracted by mini-css-extract-plugin
export default {"content":"style_content__ECNdI","itemName":"style_itemName__fIS6w"};